import "../../styles/css/dialog.css";
import * as keyCodes from "../../enums/keyCodes";
import Overlay from "./internal/Overlay";
import { Paper } from "../Paper";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ReactDOM from "react-dom";

export default class Dialog extends PureComponent {
	static propTypes = {
		actions: PropTypes.node,
		actionsContainerClassName: PropTypes.string,
		actionsContainerStyle: PropTypes.object,
		bodyClassName: PropTypes.string,
		bodyStyle: PropTypes.object,
		children: PropTypes.node,
		className: PropTypes.string,
		contentClassName: PropTypes.string,
		contentStyle: PropTypes.object,
		modal: PropTypes.bool,
		onRequestClose: PropTypes.func,
		open: PropTypes.bool.isRequired,
		overlayClassName: PropTypes.string,
		overlayStyle: PropTypes.object,
		style: PropTypes.object,
		title: PropTypes.node,
		titleClassName: PropTypes.string,
		titleStyle: PropTypes.object,
	};

	static defaultProps = {
		modal: false,
	};

	componentDidMount() {
		window.addEventListener("keyup", this._handleKeyUp);
	}

	componentWillUnmount() {
		window.removeEventListener("keyup", this._handleKeyUp);
	}

	requestClose(buttonClicked) {
		if (!buttonClicked && this.props.modal) {
			return;
		}

		if (this.props.onRequestClose) {
			this.props.onRequestClose(!!buttonClicked);
		}
	}

	handleTouchTapOverlay = () => {
		this.requestClose(false);
	};

	_handleKeyUp = e => {
		if (this.props.open && e.keyCode === keyCodes.ESCAPE) {
			this.requestClose(false);
		}
	};

	render() {
		const { actions, children, open, title } = this.props;

		if (!open) {
			return null;
		}

		const actionsContainer = React.Children.count(actions) > 0 && (
			<div
				className={`dialog-actions-container ${this.props.actionsContainerClassName}`}
				style={this.props.actionsContainerStyle}
			>
				{React.Children.toArray(actions)}
			</div>
		);

		let titleElement = title;
		if (React.isValidElement(title)) {
			titleElement = React.cloneElement(title, {
				className: `dialog-title ${title.props.className || this.props.titleClassName}`,
				style: { ...this.props.titleStyle, ...title.props.style },
			});
		} else if (typeof title === "string") {
			titleElement = (
				<h3
					className={`dialog-title ${this.props.titleClassName}`}
					style={this.props.titleStyle}
				>
					{title}
				</h3>
			);
		}

		return ReactDOM.createPortal(
			<React.Fragment>
				<div className={`dialog-root ${this.props.className}`} style={this.props.style}>
					{open && (
						<div
							className={`dialog-base-content ${this.props.contentClassName}`}
							style={this.props.contentStyle}
						>
							<Paper zDepth={4}>
								{titleElement}
								<div
									className={`dialog-body ${this.props.bodyClassName}`}
									style={{
										paddingTop: this.props.title ? 0 : 24,
										...this.props.bodyStyle,
									}}
								>
									{children}
								</div>
								{actionsContainer}
							</Paper>
						</div>
					)}
					<Overlay
						show={open}
						className={`dialog-overlay ${this.props.overlayClassName}`}
						style={this.props.overlayStyle}
						onClick={this.handleTouchTapOverlay}
					/>
				</div>
			</React.Fragment>,
			document.getElementById("modal-root"),
		);
	}
}
